import React, {useState, useEffect} from 'react';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import StyledBox from "../../components/StyledBox";
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector
} from "@mui/x-data-grid-pro";
import LinearProgress from "@mui/material/LinearProgress";
import CustomNoRowsOverlay from "../../components/CustomNoRowsOverlay";
import {useDispatch} from "react-redux";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {buildUrlWithQueryParams} from "../../components/buildUrlWithQueryParams";
import server from "../../server";
import {AxiosSyncDefaultRequest} from "../../components/default_request";
import {FBAAddressBar} from "./FBAAddressBar";
import {GridActionsCellItem} from "@mui/x-data-grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {DialogContentText, Snackbar} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {GridActionIcon} from "../../components/renderField";
import EditFormDialog from "./Dialog/EditDialog";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import CreateFormDialog from "./Dialog/createDialog";
import ToolBar from "../../components/ToolBar";

const FBAAddress = "FBAAddress";

function FBAAddressPage() {
    const [pageSize, setPageSize] = useState(100);
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [sort_data, setSortData] = useState({})
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success', // 可以是 'error', 'warning', 'info', 'success'
    });
    const [searchData, setSearchData] = useState({
        name: "", address1: "", address2: "", city: "", postal_code: "", state: "",
    });
    const dispatch = useDispatch();
    const [Visibility, setVisibility] = useState({
        id: false,
    })
    const columns = [
        {id: 1, field: "id", headerName: "ID"},
        {id: 2, field: "name", headerName: "仓库名", flex: 10},
        {id: 3, field: "address1", headerName: "地址一", flex: 15},
        {id: 4, field: "address2", headerName: "地址2", flex: 5},
        {id: 5, field: "city", headerName: "城市", flex: 12},
        {id: 6, field: "postal_code", headerName: "邮编", flex: 8},
        {id: 7, field: "state", headerName: "州/省简称", flex: 8},
        {id: 8, field: "phone", headerName: "电话", flex: 8},
        {id: 9, field: "company_name", headerName: "公司名", flex: 10},
        {id: 10, field: "country", headerName: "国家/地区", flex: 5},
        {id: 11, field: "description", headerName: "描述", flex: 10},
        {id: 12, type: 'actions', field: 'actions', headerName: "Actions", getActions: (params) => {
            return [
                <GridActionsCellItem
                    icon={<EditIcon />}
                    label="Edit"
                    title={'Edit'}
                    onClick={() => handleOpenEditDialog(params.row)}
                    key={`edit-${params.id}`}
                    color="primary"
                />,
                <GridActionsCellItem
                    icon={<DeleteIcon />}
                    label="Delete"
                    title={"Delete"}
                    onClick={() => handleOpenDeleteDialog(params.row)}
                    key={`delete-${params.id}`}
                    color="secondary"
                />
            ];
        }}
    ];

    const handleOpenEditDialog = (row) => {
        setSelectedRow(row);
        setOpenEditDialog(true);
    };
    const handleOpenDeleteDialog = (row) => {
        setSelectedRow(row);
        setOpenDeleteDialog(true);
    };
    const handleSave = (editedData, rowId, method='PUT') => {
        // 直接返回 fetchData 函数调用的 Promise
        let result = {status: false, message: ''};
        return fetchData(method, editedData, rowId, sort_data
        ).then((e) => {
            Refresh();
            result.status = e !== undefined;
            return result;
        }).catch((error) => {
            result.status = false;
            result.message = error.response.message;
            return result;
        }).finally(() => {
            return result;
        });
    }
    const fetchData = async (method, data = {}, rowId = null, sortData) => {
        try {
            const queryParams = {
                ...searchData, // 将搜索条件作为查询参数
                ...sortData,
                curr_page: currentPage + 1,
                page_size: pageSize,
            };

            let requestUrl = server.fba_address_list;
            let requestData = {};

            if (method === 'GET') {
                requestUrl = buildUrlWithQueryParams(requestUrl, queryParams);
            } else if (method === 'PUT' && rowId != null) {
                // 对于PUT请求，添加row id到URL，并设置编辑的数据作为请求体
                requestUrl = `${requestUrl}${rowId}/`;
                requestData = data;
            }else if (method === "DELETE") {
                requestUrl = `${requestUrl}${rowId}/`;
            }else if (method === "POST") {
                requestData = data;
            }

            return await AxiosSyncDefaultRequest({
                url: requestUrl,
                method: method,
                data: requestData,
                success: (res) => {
                    if (method === 'GET') {
                        setData(res.data.rows);
                        setLoading(false);
                        setTotalRows(res.data.total);
                    }
                },
                fail: (error) => {
                    console.error('请求失败', error);
                    setData([]);
                    setLoading(false);
                    const errorMessage = JSON.stringify(error.response.data);
                    setSnackbar({ open: true, message: errorMessage, severity: 'error' });
                    // throw error
                }
            });
        } catch (error) {
            console.error('请求异常', error);
        }
    };
    useEffect(() => {
        setLoading(true);
        // 调用上面定义的函数来加载数据
        fetchData('GET', {}, null, sort_data).then(r => {});
    }, [currentPage, pageSize]);
    const triggerSearch = () => {
        setData([]);
        setSearch(true);
        fetchData('GET', {}, null, sort_data).then(r => {})
        setSearch(false);
    };
    const Refresh = () => {
        setData([]);
        setLoading(true);
        fetchData('GET', {}, null, sort_data).then(r => {})
        setSearch(false);
    }
    const handleDelete = (rowId) => {
        // 直接返回 fetchData 函数调用的 Promise
        let result = {status: false, message: ''};
        return fetchData('DELETE', {}, rowId, sort_data
        ).then((e) => {
            Refresh();
            result.status = true;
            return result; // 在 then 中返回 result
        }).catch((error) => {
            result.status = false;
            result.message = error.response.message;
        }).finally(() => {
            return result;
        });
    }
    const handleSortModelChange = async (sortModel) => {
        let sort = '';
        if (sortModel.length > 0) {
            // 处理所有的排序模型，虽然通常只有一个
            sort = sortModel.map(model => {
                return model.sort === 'asc' ? model.field : `-${model.field}`;
            }).join(',');
        }
        // 构造排序的数据结构
        const sortData = { sort };
        setSortData(sortData)
        // 调用 fetchData 函数请求数据
        setLoading(true);
        setData([]);
        console.log(sortData)
        await fetchData('GET', {}, null, sortData);
    };
    const onChangeColumnVisibilityModel = (newVisibility) => {
        // if (user.is_open_claim !== "4") {
        //     newVisibility = { ...newVisibility, Check_amount: false };
        // }
        setVisibility(newVisibility);
    };
    return (
        <Box sx={{
            width: '100%'
        }}>
            <Grid container>
                <Grid container item md={12} lg={12}>
                    <Box sx={{minWidth: '100%'}}>
                        <FBAAddressBar
                            searchData={searchData}
                            setSearchData={setSearchData}
                            search={search}
                            setSearch={triggerSearch}
                            setCurrentPage={setCurrentPage}
                        />
                        <CreateFormDialog
                            onSave={handleSave}
                        />
                    </Box>
                </Grid>
                <Grid item md={12} lg={12}>
                    <StyledBox>
                        {data ? <DataGridPro
                            rows={data}
                            density="compact"
                            columns={columns}
                            pageSize={pageSize}
                            columnVisibilityModel={Visibility}
                            rowsPerPageOptions={[25, 30, 50, 100, 200, 500]}
                            checkboxSelection={false}
                            headerHeight={70}
                            loading={loading}
                            rowCount={totalRows}
                            paginationMode='server'
                            onPageChange={(page) => setCurrentPage(page)}
                            onPageSizeChange={pageSize => setPageSize(pageSize)}
                            rowReordering={false}
                            pagination={true}
                            sortingMode={handleSortModelChange}
                            onColumnVisibilityModelChange={onChangeColumnVisibilityModel}
                            components={{
                                LoadingOverlay: LinearProgress,
                                NoRowsOverlay: CustomNoRowsOverlay,
                                Toolbar: () => <ToolBar onRefresh={Refresh} />,
                            }}
                            columnBuffer={3}
                            columnThreshold={3}/> : ''}
                    </StyledBox>
                </Grid>
            </Grid>

            <EditFormDialog
                open={openEditDialog}
                onClose={() => setOpenEditDialog(false)}
                rowData={selectedRow}
                onSave={handleSave}
            />

            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>确认删除</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        确定要删除{selectedRow?.name}吗？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)}>否</Button>
                    <LoadingButton
                        loading={deleteLoading}
                        variant={"contained"}
                        onClick={() => {
                            setDeleteLoading(true);
                            handleDelete(selectedRow.id).then(result => {
                                if (result.status === true) {
                                    // 操作成功，显示成功消息
                                    setSnackbar({ open: true, message: '删除成功！', severity: 'success' });
                                } else {
                                    // 操作失败，显示错误消息
                                    setSnackbar({ open: true, message: '删除失败，请重试.', severity: 'error' });
                                }
                                setDeleteLoading(false);
                                setOpenDeleteDialog(false);
                            }
                        ).catch((error) => {
                                console.error("删除失败.", error);
                        }).finally(() => {

                            })
                        }}
                    >是</LoadingButton>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    )
}

export default FBAAddress;
export {FBAAddressPage};